module.exports = __webpack_public_path__ + "static/media/kod_girisi_ADIM3.5d7e7914.jpg";